<template>
  <SuccessForm
    :title="'verificationStatus.openAccount.successOpenAccount.successTitle'"
    :desc="'verificationStatus.openAccount.successOpenAccount.successDesc'"
    :lists="lists"
    :primaryButtonLabel="'verificationStatus.depositNow'"
    :primaryButtonOnClick="onPrimaryButtonOnClick"
    :secondaryButtonLabel="'verificationStatus.openAccount.successOpenAccount.successSecondaryButtonLabel'"
    :secondaryButtonOnClick="onSecondaryButtonOnClick"
  />
</template>

<script>
import SuccessForm from '@/components/register/registerForms/SuccessForm.vue';
import auditStatus from '@/constants/auditStatus';
import { RegisterRoutePath } from '@/router/registerRoutes';
import { sensorsTrack } from '@/util/sensorsdata';
import { SENSORS_TRACK } from '@/util/sensorsdata/constant';

export default {
  name: 'SuccessOpenAccount',
  components: { SuccessForm },
  computed: {
    accountAuditStatus() {
      return this.$store.state.common.accountAuditStatus;
    },
    isSuccess() {
      return this.accountAuditStatus === auditStatus.completed;
    }
  },
  created() {
    this.RegisterRoutePath = RegisterRoutePath;
    this.lists = [
      {
        name: '1',
        title: 'verificationStatus.openAccount.successOpenAccount.successFaqTitle1',
        desc: `verificationStatus.openAccount.successOpenAccount.successFaqDesc1`
      },
      {
        name: '2',
        title: 'verificationStatus.openAccount.successOpenAccount.successFaqTitle2',
        desc: `verificationStatus.openAccount.successOpenAccount.successFaqDesc2`
      },
      {
        name: '3',
        title: 'verificationStatus.openAccount.successOpenAccount.successFaqTitle3',
        desc: `verificationStatus.openAccount.successOpenAccount.successFaqDesc3`
      }
    ];
  },
  methods: {
    onPrimaryButtonOnClick() {
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_CLICK, {
        openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV1,
        openidentity_step: SENSORS_TRACK.IDENTITY_STEP.LV1_ACCOUNT_PASSED,
        button_name: SENSORS_TRACK.BUTTON_NAME.LV1_DEPOSIT
      })
      this.$router.push('/depositFunds');
    },
    onSecondaryButtonOnClick() {
      sensorsTrack(SENSORS_TRACK.EVENT_NAME.OPEN_IDENTITY_PAGE_CLICK, {
        openidentity_level: SENSORS_TRACK.IDENTITY_LEVEL.LV1,
        openidentity_step: SENSORS_TRACK.IDENTITY_STEP.LV1_ACCOUNT_PASSED,
        button_name: SENSORS_TRACK.BUTTON_NAME.LV1_NEXT
      })
      this.$router.push(this.RegisterRoutePath.identityVerification)
    }
  }

};
</script>
